import React from 'react';

function Filter() {
	return (
		<div>
			<div className="wraper container-fluid dashboard-container">
				<div className="top-header ">
					{/* Filter Contanier top*/}
					<div className="page-title-area">
						<h1 className="semibold-16">Supplier list</h1>
					</div>
					<div className="filter-container-top filter-container-top-v2 bg-white">
						<div className="filters">
							<div className="filter-toggle">
								<img alt="filter" src=" /icons/filter24.svg" />
								<img alt="filter" className="d-none" src=" /icons/filter-close.svg" />
								<span>Filter</span>
							</div>
							<div className="chip-container">
								<div className="chips">
									<div className="chip">
										<span>Aminul islam hasan</span>
										<span className="chip-close cursor-pointer">
											<img src="./icons/close.svg" alt="" width={12} height={12} />
										</span>
									</div>
									<div className="chip">
										<span>Aminul islam hasan</span>
										<span className="chip-close cursor-pointer">
											<img src="./icons/close.svg" alt="" />
										</span>
									</div>
									<div className="chip">
										<span>Aminul islam hasan</span>
										<span className="chip-close cursor-pointer">
											<img src="./icons/close.svg" alt="" />
										</span>
									</div>
									<div className="chip">
										<span>Aminul islam hasan</span>
										<span className="chip-close cursor-pointer">
											<img src="./icons/close.svg" alt="" />
										</span>
									</div>
								</div>
								<span className="clear">Clear all</span>
							</div>
						</div>
						{/*Filter Actions*/}
						<div className="filter-actions collections-filter-actions">
							<div className="form-group size32 m-0 mr-3 search-filter filter-with-animation">
								<div className="with-icon right-icon hidden">
									<input placeholder="RoleWiseCollection name" type="text" />
									<span className="right-icon">
										<img src="/icons/search-dark.svg" />
									</span>
								</div>
							</div>
							<div className="quick-btn mr-3">
								<button className="size32 rounded-0 chip">Quick Search</button>
							</div>
							<div className="grid-view d-flex mr-3">
								<span className="active-view mr-3">
									<img alt="add" src=" /icons/grid.svg" />
								</span>
								<span>
									<img alt="add" src=" /icons/list.svg" />
								</span>
							</div>
							<div className="sort-button mr-3">
								<select className="border-0" id name>
									<option value>Newest first</option>
									<option value>Oldest</option>
									<option value>Last modified</option>
								</select>
							</div>
							<div className="add-new-design">
								<button className="button text size32 px-0">
									<img alt="add" src=" /icons/add-round.svg" />
									<span className="ml-1">Suppiler</span>
								</button>
							</div>
						</div>
					</div>
				</div>
				{/* Filter Data container */}
				<section className="filter-data-container filter-v3-data-container">
					<div className="filter-bar-section open">
						<div className="filter-content-v3">
							<div className="filter-nav">
								<ul>
									<li className="regular-14 gray_dark_01 d-flex justify-content-between">
										<span>Supplier Grade</span>
										<span>
											<img alt="right" src=" /icons/right-arrow.svg" />
										</span>
									</li>
									<li className="regular-14 gray_dark_01 d-flex justify-content-between">
										<span> Supplier Type</span>
										<span>
											<img alt="right" src=" /icons/right-arrow.svg" />
										</span>
									</li>
									<li className="regular-14 gray_dark_01 d-flex justify-content-between">
										<span> Supplier Status</span>
										<span>
											<img alt="right" src=" /icons/right-arrow.svg" />
										</span>
									</li>
									<li className="regular-14 gray_dark_01 d-flex justify-content-between">
										<span> Supplier Grade</span>
										<span>
											<img alt="right" src=" /icons/right-arrow.svg" />
										</span>
									</li>
									<li className="regular-14 gray_dark_01 d-flex justify-content-between">
										<span> Fabric Type</span>
										<span>
											<img alt="right" src=" /icons/right-arrow.svg" />
										</span>
									</li>
									<li className="regular-14 gray_dark_01 d-flex justify-content-between">
										<span> Location</span>
										<span>
											<img alt="right" src=" /icons/right-arrow.svg" />
										</span>
									</li>
									<li className="regular-14 gray_dark_01 d-flex justify-content-between">
										<span> Brands</span>
										<span>
											<img alt="right" src=" /icons/right-arrow.svg" />
										</span>
									</li>
									<li className="regular-14 gray_dark_01 d-flex justify-content-between">
										<span> Certificate</span>
										<span>
											<img alt="right" src=" /icons/right-arrow.svg" />
										</span>
									</li>
									<li className="regular-14 gray_dark_01 d-flex justify-content-between">
										<span> Certificate strength</span>
										<span>
											<img alt="right" src=" /icons/right-arrow.svg" />
										</span>
									</li>
									<li className="regular-14 gray_dark_01 d-flex justify-content-between">
										<span> Audit</span>
										<span>
											<img alt="right" src=" /icons/right-arrow.svg" />
										</span>
									</li>
									<li className="regular-14 gray_dark_01 d-flex justify-content-between">
										<span> Price Range </span>
										<span>
											<img alt="right" src=" /icons/right-arrow.svg" />
										</span>
									</li>
								</ul>
							</div>
							<div className="filter-submenu scroll-y-label scroll-y-none">
								<div className="card border-0">
									<div className="card-body">
										<div className="form-group size36 m-0 search-filter mb-3">
											<div className="with-icon right-icon">
												<input placeholder="Search" type="text" />
												<span className="right-icon">
													<img alt="" src=" /icons/search.png" />
												</span>
											</div>
										</div>
										<div className="custom-chekbox">
											<div className="form-group certificate-group ">
												<div
													className="regular-14 d-flex align-items-center"
													htmlFor="person1"
												>
													<span>Supplier Rank</span>
													<div className="strenght-grade-info cursor-pointer">
														<img alt="sm" src=" /icons/info.svg" width="20px" />
														<div className="strength-modal shadow-2dp">
															<div className="strength-modal-body">
																<table className="table with-border height-sm hover">
																	<tbody>
																		<tr>
																			<td className="regular-14 weight-500">
																				Social &amp; Environmental
																			</td>
																			<td>
																				BSCI, SEDEX, HIGG FEM,BETTER
																				WORK
																			</td>
																		</tr>
																		<tr>
																			<td className="regular-14 weight-500">
																				Security
																			</td>
																			<td>
																				WRAP/SECURITY/ SCAN/GSV/
																				CT-PAT
																			</td>
																		</tr>
																		<tr className="regular-14 weight-500">
																			<td>Sustainability</td>
																			<td>
																				BCI, OCS, RCS, GRS,GOTS,
																				OEKO-TEX
																			</td>
																		</tr>
																	</tbody>
																</table>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div className="form-group">
												<input
													id="person2"
													name="Company"
													type="checkbox"
													defaultValue="{113}"
												/>
												<label className="regular-14" htmlFor="person2">
													<span>Grade - 4</span>
												</label>
											</div>
											<div className="form-group">
												<input
													id="person3"
													name="Company"
													type="checkbox"
													defaultValue="{113}"
												/>
												<label className="regular-14" htmlFor="person3">
													<span>Grade - 4</span>
												</label>
											</div>
											<div className="form-group">
												<input
													id="person4"
													name="Company"
													type="checkbox"
													defaultValue="{113}"
												/>
												<label className="regular-14" htmlFor="person4">
													<span>Grade - 3</span>
												</label>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="data-table">
						<div className="supplier-collections-container">
							<div className="supplier-row">
								<div className="supplier-card-single">
									<div className="supplier-img">
										<img alt="add" src=" /images/supplier2.jpg" />
										<span className="status green-3 round">Active</span>
									</div>
									<div className="supplier-card-content">
										<div className="title-and-grade d-flex justify-content-between align-items-center">
											<div>
												<h3 className="semibold-20 font-weight-bold">
													Sinha knit &amp; Denims Ltd.
												</h3>
											</div>
											<div className="grade-list">
												<span className="factory-grade gradeA font-weight-bold">
													A
												</span>
											</div>
										</div>
										<p className="regular-12 gray_dark_02">Dhaka, Bangladesh</p>
										<div className="status-nav">
											<ul className="d-flex">
												<li className="mr-1">
													<span className="status cyan-1">Garments</span>
												</li>
												<li className="mr-1">
													<span className="status cyan-1">Fabrics</span>
												</li>
												<li className="mr-1">
													<span className="status cyan-1">Knit</span>
												</li>
											</ul>
										</div>
										<div className="brand-nav">
											<ul className="d-flex">
												<li className="mr-1">
													<span className="status gray-1 radius">ADORE ME</span>
												</li>
												<li className="mr-1">
													<span className="status gray-1 radius">Zalando</span>
												</li>
												<li className="mr-1">
													<span className="status gray-1 radius">Zara</span>
												</li>
												<li className="mr-1">
													<span className="status gray-1 radius">+12</span>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div className="supplier-card-single">
									<div className="supplier-img">
										<img alt="add" src=" /images/supplier2.jpg" />
										<div className="supplier-status">
											<span className="status red-3">Not Working</span>
										</div>
									</div>
									<div className="supplier-card-content">
										<div className="title-and-grade d-flex justify-content-between align-items-center">
											<div>
												<h3 className="semibold-20 font-weight-bold">
													Sinha knit &amp; Denims Ltd.
												</h3>
											</div>
											<div className="grade-list">
												<span className="factory-grade gradeA font-weight-bold">
													A
												</span>
											</div>
										</div>
										<p className="regular-12 gray_dark_02">Dhaka, Bangladesh</p>
										<div className="status-nav">
											<ul className="d-flex">
												<li className="mr-1">
													<span className="status cyan-1">Garments</span>
												</li>
												<li className="mr-1">
													<span className="status cyan-1">Fabrics</span>
												</li>
												<li className="mr-1">
													<span className="status cyan-1">Knit</span>
												</li>
											</ul>
										</div>
										<div className="brand-nav">
											<ul className="d-flex">
												<li className="mr-1">
													<span className="status gray-1 radius">ADORE ME</span>
												</li>
												<li className="mr-1">
													<span className="status gray-1 radius">Zalando</span>
												</li>
												<li className="mr-1">
													<span className="status gray-1 radius">Zara</span>
												</li>
												<li className="mr-1">
													<span className="status gray-1 radius">+12</span>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div className="supplier-card-single">
									<div className="supplier-img">
										<img alt="add" src=" /images/supplier2.jpg" />
										<div className="supplier-status">
											<span className="status gray-3 round">Black listed</span>
										</div>
									</div>
									<div className="supplier-card-content">
										<div className="title-and-grade d-flex justify-content-between align-items-center">
											<div>
												<h3 className="semibold-20 font-weight-bold">
													Sinha knit &amp; Denims Ltd.
												</h3>
											</div>
											<div className="grade-list">
												<span className="factory-grade gradeC font-weight-bold">
													C
												</span>
											</div>
										</div>
										<p className="regular-12 gray_dark_02">Dhaka, Bangladesh</p>
										<div className="status-nav">
											<ul className="d-flex">
												<li className="mr-1">
													<span className="status cyan-1">Garments</span>
												</li>
												<li className="mr-1">
													<span className="status cyan-1">Fabrics</span>
												</li>
												<li className="mr-1">
													<span className="status cyan-1">Knit</span>
												</li>
											</ul>
										</div>
										<div className="brand-nav">
											<ul className="d-flex">
												<li className="mr-1">
													<span className="status gray-1 radius">ADORE ME</span>
												</li>
												<li className="mr-1">
													<span className="status gray-1 radius">Zalando</span>
												</li>
												<li className="mr-1">
													<span className="status gray-1 radius">Zara</span>
												</li>
												<li className="mr-1">
													<span className="status gray-1 radius">+12</span>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div className="supplier-card-single">
									<div className="supplier-img">
										<img alt="add" src=" /images/factory-demo.jpg" />
										<div className="supplier-status">
											<span className="status yellow-3">Pipeline</span>
										</div>
									</div>
									<div className="supplier-card-content">
										<div className="title-and-grade d-flex justify-content-between align-items-center">
											<div>
												<h3 className="semibold-20 font-weight-bold">
													Sinha knit &amp; Denims Ltd.
												</h3>
											</div>
											<div className="grade-list">
												<span className="factory-grade gradeB font-weight-bold">
													B
												</span>
											</div>
										</div>
										<p className="regular-12 gray_dark_02">Dhaka, Bangladesh</p>
										<div className="status-nav">
											<ul className="d-flex">
												<li className="mr-1">
													<span className="status cyan-1">Garments</span>
												</li>
												<li className="mr-1">
													<span className="status cyan-1">Fabrics</span>
												</li>
												<li className="mr-1">
													<span className="status cyan-1">Knit</span>
												</li>
											</ul>
										</div>
										<div className="brand-nav">
											<ul className="d-flex">
												<li className="mr-1">
													<span className="status gray-1 radius">ADORE ME</span>
												</li>
												<li className="mr-1">
													<span className="status gray-1 radius">Zalando</span>
												</li>
												<li className="mr-1">
													<span className="status gray-1 radius">Zara</span>
												</li>
												<li className="mr-1">
													<span className="status gray-1 radius">+12</span>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div className="supplier-card-single">
									<div className="supplier-img">
										<img alt="add" src=" /images/supplier2.jpg" />
										<div className="supplier-status">
											<span className="status gray-3">Black listed</span>
										</div>
									</div>
									<div className="supplier-card-content">
										<div className="title-and-grade d-flex justify-content-between align-items-center">
											<div>
												<h3 className="semibold-20 font-weight-bold">
													Sinha knit &amp; Denims Ltd.
												</h3>
											</div>
											<div className="grade-list">
												<span className="factory-grade gradeD font-weight-bold">
													D
												</span>
											</div>
										</div>
										<p className="regular-12 gray_dark_02">Dhaka, Bangladesh</p>
										<div className="status-nav">
											<ul className="d-flex">
												<li className="mr-1">
													<span className="status cyan-1">Garments</span>
												</li>
												<li className="mr-1">
													<span className="status cyan-1">Fabrics</span>
												</li>
												<li className="mr-1">
													<span className="status cyan-1">Knit</span>
												</li>
											</ul>
										</div>
										<div className="brand-nav">
											<ul className="d-flex">
												<li className="mr-1">
													<span className="status gray-1 radius">ADORE ME</span>
												</li>
												<li className="mr-1">
													<span className="status gray-1 radius">Zalando</span>
												</li>
												<li className="mr-1">
													<span className="status gray-1 radius">Zara</span>
												</li>
												<li className="mr-1">
													<span className="status gray-1 radius">+12</span>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div className="supplier-card-single">
									<div className="supplier-img">
										<img alt="add" src=" /images/supplier2.jpg" />
										<div className="supplier-status">
											<span className="status green-3 mr-1 mb-2 ">active</span>
										</div>
									</div>
									<div className="supplier-card-content">
										<div className="title-and-grade d-flex justify-content-between align-items-center">
											<div>
												<h3 className="semibold-20 font-weight-bold">
													Sinha knit &amp; Denims Ltd.
												</h3>
											</div>
											<div className="grade-list">
												<span className="factory-grade gradeA font-weight-bold">
													A
												</span>
											</div>
										</div>
										<p className="regular-12 gray_dark_02">Dhaka, Bangladesh</p>
										<div className="status-nav">
											<ul className="d-flex">
												<li className="mr-1">
													<span className="status cyan-1">Garments</span>
												</li>
												<li className="mr-1">
													<span className="status cyan-1">Fabrics</span>
												</li>
												<li className="mr-1">
													<span className="status cyan-1">Knit</span>
												</li>
											</ul>
										</div>
										<div className="brand-nav">
											<ul className="d-flex">
												<li className="mr-1">
													<span className="status gray-1 radius">ADORE ME</span>
												</li>
												<li className="mr-1">
													<span className="status gray-1 radius">Zalando</span>
												</li>
												<li className="mr-1">
													<span className="status gray-1 radius">Zara</span>
												</li>
												<li className="mr-1">
													<span className="status gray-1 radius">+12</span>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div className="supplier-card-single">
									<div className="supplier-img">
										<img alt="add" src=" /images/supplier2.jpg" />
										<div className="supplier-status">
											<span className="status green-3 mr-1 mb-2">active</span>
										</div>
									</div>
									<div className="supplier-card-content">
										<div className="title-and-grade d-flex justify-content-between align-items-center">
											<div>
												<h3 className="semibold-20 font-weight-bold">
													Sinha knit &amp; Denims Ltd.
												</h3>
											</div>
											<div className="grade-list">
												<span className="factory-grade gradeA font-weight-bold">
													A
												</span>
											</div>
										</div>
										<p className="regular-12 gray_dark_02">Dhaka, Bangladesh</p>
										<div className="status-nav">
											<ul className="d-flex">
												<li className="mr-1">
													<span className="status cyan-1">Garments</span>
												</li>
												<li className="mr-1">
													<span className="status cyan-1">Fabrics</span>
												</li>
												<li className="mr-1">
													<span className="status cyan-1">Knit</span>
												</li>
											</ul>
										</div>
										<div className="brand-nav">
											<ul className="d-flex">
												<li className="mr-1">
													<span className="status gray-1 radius">ADORE ME</span>
												</li>
												<li className="mr-1">
													<span className="status gray-1 radius">Zalando</span>
												</li>
												<li className="mr-1">
													<span className="status gray-1 radius">Zara</span>
												</li>
												<li className="mr-1">
													<span className="status gray-1 radius">+12</span>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div className="supplier-card-single">
									<div className="supplier-img">
										<img alt="add" src=" /images/supplier2.jpg" />
										<div className="supplier-status">
											<span className="status green-3 mr-1 mb-2">active</span>
										</div>
									</div>
									<div className="supplier-card-content">
										<div className="title-and-grade d-flex justify-content-between align-items-center">
											<div>
												<h3 className="semibold-20 font-weight-bold">
													Sinha knit &amp; Denims Ltd.
												</h3>
											</div>
											<div className="grade-list">
												<span className="factory-grade gradeA font-weight-bold">
													A
												</span>
											</div>
										</div>
										<p className="regular-12 gray_dark_02">Dhaka, Bangladesh</p>
										<div className="status-nav">
											<ul className="d-flex">
												<li className="mr-1">
													<span className="status cyan-1">Garments</span>
												</li>
												<li className="mr-1">
													<span className="status cyan-1">Fabrics</span>
												</li>
												<li className="mr-1">
													<span className="status cyan-1">Knit</span>
												</li>
											</ul>
										</div>
										<div className="brand-nav">
											<ul className="d-flex">
												<li className="mr-1">
													<span className="status gray-1 radius">ADORE ME</span>
												</li>
												<li className="mr-1">
													<span className="status gray-1 radius">Zalando</span>
												</li>
												<li className="mr-1">
													<span className="status gray-1 radius">Zara</span>
												</li>
												<li className="mr-1">
													<span className="status gray-1 radius">+12</span>
												</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	);
}
export default Filter;
